import Button from "components/Button";
import SvgClose from "assets/svgs/close-button-current.svg";
import Cookie from "js-cookie";

const handleClick = (setShowWeNeedHelp) => {
  setShowWeNeedHelp(false);
  Cookie.set("unc_we_need_help", "dismissed", { expires: 3 });
};

const WeNeedHelp = ({ className, setShowWeNeedHelp }) => {
  return (
    <section className={`max-w-6xl mx-auto px-4 relative lg:px-0 ${className}`}>
      <article className="bg-red p-4 text-center lg:flex lg:items-center lg:justify-between">
        <h2 className="font-bold text-xl text-white lg:text-2xl">
          We need your help
        </h2>
        <p className="my-2 text-white lg:my-0">
          Our cold case database is in danger of no longer being maintained.
        </p>
        <Button emphasis="black" height="40" href="/support-us">
          Learn More and Give
        </Button>
        <button
          className="absolute flex justify-center h-12 items-center right-4 text-black top-8 w-12 lg:static hover:text-white"
          onClick={() => handleClick(setShowWeNeedHelp)}
        >
          <span className="hidden">Close</span>
          <SvgClose className="w-4" />
        </button>
      </article>
    </section>
  );
};

export default WeNeedHelp;
